import { trans } from "../../utils/utilsTrans";

const DEFAULT_TRANSLATIONS = {
  title: 'This screen has gone to find you the ideal property, it will be back soon',
  text_1: 'This screen is under maintenance.',
  text_2: 'But we remain available to present you our best offers.',
  question: 'You manage the display of this screen?',
  answer: 'Connect a slideshow or go to the clap.show help section',
  missing_data_answer: 'Connect a slideshow and link it to your data sources or go to the clap.show help section',
};

const ErrorScreen = ({ isMissingData, translations }) => {
  return (
    <div className='error-screen'>
      <div className='left'>
        <div className='left-contain'>
          <span className='title'>{trans('error.title', translations, DEFAULT_TRANSLATIONS.title)}</span>
          <span className='text'>{trans('error.text_1', translations, DEFAULT_TRANSLATIONS.text_1)}</span>
          <span className='text'>{trans('error.text_2', translations, DEFAULT_TRANSLATIONS.text_2)}</span>
        </div>
      </div>
      <div className='right' style={{ backgroundImage: 'url(/public/images/error_screen.jpg)' }} />
      <div className='help'>
        <span>{trans('error.question', translations, DEFAULT_TRANSLATIONS.question)}</span>
        <span>{trans(`error.${isMissingData ? 'missing_data_answer' : 'answer'}`, translations, DEFAULT_TRANSLATIONS[isMissingData ? 'missing_data_answer' : 'answer'])}</span>
      </div>
    </div>
  )
}

export default ErrorScreen
